import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Zap, Users, Target, Flag, Calendar, Monitor, Wrench, Sun, Moon, } from 'lucide-react';
// =============================================================================
// DEFAULT SECTIONS
// =============================================================================
export const DEFAULT_RAIL_SECTIONS = [
    { key: 'execution', icon: Zap, label: 'Execution' },
    { key: 'customers', icon: Users, label: 'Customers' },
    { key: 'opportunities', icon: Target, label: 'Opportunities' },
    { key: 'strategies', icon: Flag, label: 'Strategies' },
    { key: 'schedule', icon: Calendar, label: 'Schedule' },
    { key: 'presentations', icon: Monitor, label: 'Presentations' },
    { key: 'tools', icon: Wrench, label: 'Tools' },
];
// =============================================================================
// RAIL ITEM
// =============================================================================
function RailItem({ icon: Icon, label, active, onClick }) {
    return (_jsx("div", { title: label, onClick: onClick, style: {
            width: 38,
            height: 38,
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            background: active ? 'var(--cc-accent-tint)' : 'transparent',
            transition: 'background 0.14s ease',
        }, onMouseOver: (e) => {
            if (!active)
                e.currentTarget.style.background = 'var(--cc-field)';
        }, onMouseOut: (e) => {
            if (!active)
                e.currentTarget.style.background = 'transparent';
        }, children: _jsx(Icon, { size: 18, style: { color: active ? 'var(--cc-accent)' : 'var(--cc-text-3)' } }) }));
}
// =============================================================================
// RAIL COMPONENT
// =============================================================================
export function Rail({ activeSection = 'execution', onSectionChange, theme = 'dark', onThemeToggle, userInitials = '', logoChar = 'P', sections = DEFAULT_RAIL_SECTIONS, }) {
    return (_jsxs("div", { style: {
            width: 62,
            flexShrink: 0,
            borderRight: '1px solid var(--cc-border)',
            background: 'var(--cc-surface-2)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '14px 0',
            gap: 5,
        }, children: [_jsx("div", { style: {
                    width: 32,
                    height: 32,
                    borderRadius: 9,
                    background: 'var(--cc-accent)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontWeight: 800,
                    fontSize: 16,
                    marginBottom: 12,
                }, children: logoChar }), sections.map((section) => (_jsx(RailItem, { icon: section.icon, label: section.label, active: activeSection === section.key, onClick: () => onSectionChange?.(section.key) }, section.key))), _jsx("div", { style: { marginTop: 'auto' } }), _jsx("div", { onClick: onThemeToggle, style: {
                    width: 34,
                    height: 34,
                    borderRadius: 9,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    color: 'var(--cc-text-2)',
                }, onMouseOver: (e) => {
                    e.currentTarget.style.background = 'var(--cc-field)';
                }, onMouseOut: (e) => {
                    e.currentTarget.style.background = 'transparent';
                }, children: theme === 'dark' ? _jsx(Sun, { size: 17 }) : _jsx(Moon, { size: 17 }) }), _jsx("div", { style: {
                    width: 30,
                    height: 30,
                    borderRadius: '50%',
                    background: 'var(--cc-border-strong)',
                    border: '2px solid var(--cc-surface)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 10,
                    fontWeight: 800,
                    color: 'var(--cc-text-2)',
                    fontFamily: "'JetBrains Mono', monospace",
                    marginTop: 8,
                }, children: userInitials })] }));
}
export default Rail;
